/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */ 
var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};
jQuery(document).ready(function(){
    
    $(".ShopTheLook__Dot").on("click", function(e){
        e.preventDefault();
        if($(this).hasClass("is-active"))
        {

        }
        else
        {
            $(".ShopTheLook__Dot").removeClass("is-active");
            $(this).addClass("is-active");
        }
    });
    if(jQuery(".ProductMeta__StoreAvailabilityContainer").length > 0)
    {
        jQuery.ajax({
            type: 'GET',
            url: 'https://ipapi.co/json/',
            dataType: 'json',
            success: function(data) {
                var shipping;
                var country = data.country; 
                
                var countryName = data.country_name; 
              
                if(country == 'NL')
                {
                    jQuery('.ProductMeta__StoreAvailabilityContainer').css('display', 'block');
                    $('.stock_management').show();
                    $('.SizeSwatchList .SizeSwatch__Radio').removeAttr('checked');
                }
                else if(window.location.href.indexOf('nl') > -1){
                    jQuery('.ProductMeta__StoreAvailabilityContainer').css('display', 'block');
                    $('.stock_management').show();
                    $('.SizeSwatchList .SizeSwatch__Radio').removeAttr('checked');
                }
                else{
                  $('.stock_management').hide();
                }
          
            }
        });
    }
    
    jQuery.ajax({
            type: 'GET',
            url: '/browsing_context_suggestions.json',
            dataType: 'json',
            success: function(data) {
                var shipping;
                var country = data.detected_values.country.handle; 
                var countryName = data.detected_values.country_name; 

                var en_text = '';
                var nl_text = '';
                var da_text = '';

                if(country == 'NL'){
                  $('body').attr('data-checkout-storepickup',nl_text);
                }
                else if(country == 'DA'){
                  $('body').attr('data-checkout-storepickup',da_text);
                }
                else if(country == 'DE'){
                  $('.ProductForm__AddToCart .addtocartspan').text('Læg i kurv');
                }
                else{
                  $('body').attr('data-checkout-storepickup',en_text);
                }
            }
    });

	if(jQuery(".reviews-carousal-wrapper .single-review-wrapper").length > 0)
	{
		jQuery(".reviews-carousal-wrapper .custom-row").slick({
			slidesToShow: 3,
		  	slidesToScroll: 1,
		  	arrows: true,
			dots: false,
			infinite: true,
			// autoplay: true,
  			// autoplaySpeed: 3000,
  			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
  			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
		  	responsive: [
		  		{
			      	breakpoint: 1199,
			      	settings: {
			      		slidesToShow: 2,
			      	}
			    },
		  		{
			      	breakpoint: 767,
			      	settings: {
			      		slidesToShow: 1
			      	}
			    }
		  	]
		});
	}
	if(jQuery(".logo-carousal ul li").length > 0)
	{
		jQuery(".logo-carousal ul").slick({
			slidesToShow: 5,
		  	slidesToScroll: 1,
		  	arrows: false,
			dots: false,
			infinite: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
  			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
		  	responsive: [
		  		{
			      	breakpoint: 1199,
			      	settings: {
			      		slidesToShow: 2,
			      		arrows: true
			      	}
			    },
		  		{
			      	breakpoint: 767,
			      	settings: {
			      		slidesToShow: 1,
			      		arrows: true
			      	}
			    }
		  	]
		});
	}
  
  // Features modal slider
  var currentSlide = "" ;
  $('.features__item').on('click', function(){
    var id = $(this).data('target');
    $(id).modal('show');
    currentSlide = $(this).data('current-feature') - 1;
  });
  $('.CollectionToolbar__Item--size').on('click', function(){
    var id = $(this).data('target');
    $(id).modal('show');
  });
  
    $('.features__description-list').on('init', function(event, slick){
        $('.features__description-list').css("max-height", "unset");
    });
    $('#featuresModal').on('shown.bs.modal', function () {
        if($('.features__description-list').hasClass("slick-initialized"))
        {
            // $('.features__description-list').slick('refresh');
        }
        else
        {
            $('.features__description-list').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
            });
        }
        console.log(currentSlide);
        $('.features__description-list').slick('slickGoTo', currentSlide, true);
    });
    
  
  $(document).on('click', '#closeModal', function(){
    $('#fitGuideModal').modal('hide');
  });
  $(document).on('click', '.CollectionToolbar__Item[data-target="#fitGuideModal"]', function(){
    $('#fitGuideModal').modal('show');
  });
  
//    $('#fitGuideModal').on('shown.bs.modal', function () {
//     alert("I want this to appear after the modal has opened!");
//   });
  
  // Accordions
  if($('.accordion').length)
  {
    $('.accordion').accordion({
    "transitionSpeed": 300
  });
  }
  
  
  /* scroll to target */
  $(document).on('click','.scrollTo.CollectionToolbar__Item' ,function(e) {
		e.preventDefault();
    e.stopPropagation();
    if ($(this).data('offset') != undefined) offset = $(this).data('offset');
    $('html, body').animate({scrollTop: $('#shopify-section-collection-template').offset().top }, 1000);
    setTimeout(function(){ $('[data-drawer-id="collection-filter-drawer"]').trigger('click');}, 2000);
  });   

  $(document).on('click','.Product__Wrapper [data-section-id="usp-icons"]',function(e){
    e.preventDefault();
    $('html, body').animate({scrollTop: $(".dark-green-background").offset().top }, 1000);
  });
});




$(document).ready(function(){

  //hides dropdown content
  $(".size_chart").hide();
  
  //unhides first option content
  $("#option1").show();
  
  //listen to dropdown for change
  if($(".custom-select").length)
  {
    $(".custom-select").select2({
        minimumResultsForSearch: -1
      });
  }
  
  $("#size_select").change(function(){
    //rehide content on change
    $('.size_chart').hide();
    //unhides current item
    $('#'+$(this).val()).show();
  });
  
});




$(document).ready(function(){

  //hides dropdown content
  $(".size_chartss").hide();
  
  //unhides first option content
  $("#option6").show();
  
  //listen to dropdown for change
  $("#size_selects").change(function(){
    //rehide content on change
    $('.size_chartss').hide();
    //unhides current item
    $('#'+$(this).val()).show();
  });
  
});



$(document).ready(function(){

  //hides dropdown content
  $(".size_chartss1").hide();
  
  //unhides first option content
  $("#option15").show();
  
  //listen to dropdown for change
  $("#size_selects1").change(function(){
    //rehide content on change
    $('.size_chartss1').hide();
    //unhides current item
    $('#'+$(this).val()).show();
  });
  
});






$(document).ready(function(){

  //hides dropdown content
  $(".size_chartss12").hide();
  
  //unhides first option content
  $("#option17").show();
  
  //listen to dropdown for change
  $("#size_selects2").change(function(){
    //rehide content on change
    $('.size_chartss12').hide();
    //unhides current item
    $('#'+$(this).val()).show();
  });
  
});










$(document).ready(function(){

  //hides dropdown content
  $(".size_chartss123").hide();
  
  //unhides first option content
  $("#option22").show();
  
  //listen to dropdown for change
  $("#size_selects3").change(function(){
    //rehide content on change
    $('.size_chartss123').hide();
    //unhides current item
    $('#'+$(this).val()).show();
  });
  
});







// $(document).ready(function(){

//   //hides dropdown content
//   $(".size_chart1").hide();
  
//   //unhides first option content
//   $("#option1").show();
  
//   //listen to dropdown for change
//   $("#size_select1").change(function(){
//     //rehide content on change
//     $('.size_chart1').hide();
//     //unhides current item
//     $('#'+$(this).val()).show();
//   });
  
// });



  


$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs a').click(function(e){
    e.preventDefault();
     $('.panel').hide();
     $('.tabs a.active').removeClass('active');
     $(this).addClass('active');
     
     var panel = $(this).attr('href');
     $("#"+panel).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs li:first a').click();
     
}); // end ready




$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs_1 a').click(function(){
  
     $('.panel_1').hide();
     $('.tabs_1 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panels = $(this).attr('href');
     $(panels).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs_1 li:first a').click();
     
}); // end ready
$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs_4way div').click(function(){
     $('.panel_4way').hide();
     $('.tabs_4way div.active').removeClass('active');
     $(this).addClass('active');
     
     var panels = $(this).attr('href');
     $("#" + panels).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs_4way li:first div').click();
     
}); // end ready


$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs_2 a').click(function(){
  
     $('.panel_2').hide();
     $('.tabs_2 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss = $(this).attr('href');
     $(panelss).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs_2 li:first a').click();
     
}); // end ready










$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs_3 a').click(function(){
  
     $('.panel_3').hide();
     $('.tabs_3 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1 = $(this).attr('href');
     $(panelss1).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs_3 li:first a').click();
     
}); // end ready




$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs_4 a').click(function(){
  
     $('.panel_4').hide();
     $('.tabs_4 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss12 = $(this).attr('href');
     $(panelss12).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs_4 li:first a').click();
     
}); // end ready




$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs11 a').click(function(){
  
     $('.panel11').hide();
     $('.tabs11 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss123 = $(this).attr('href');
     $(panelss123).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs11 li:first a').click();
     
}); // end ready









$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs12 a').click(function(){
  
     $('.panel12').hide();
     $('.tabs12 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs12 li:first a').click();
     
}); // end ready








$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs13 a').click(function(){
  
     $('.panel13').hide();
     $('.tabs13 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs13 li:first a').click();
     
}); // end ready













$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs14 a').click(function(){
  
     $('.panel14').hide();
     $('.tabs14 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs14 li:first a').click();
     
}); // end ready








$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs15 a').click(function(){
  
     $('.panel15').hide();
     $('.tabs15 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs15 li:first a').click();
     
}); // end ready


$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs16 a').click(function(){
  
     $('.panel16').hide();
     $('.tabs16 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs16 li:first a').click();
     
}); // end ready







$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs17 a').click(function(){
  
     $('.panel17').hide();
     $('.tabs17 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs17 li:first a').click();
     
}); // end ready











$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs18 a').click(function(){
  
     $('.panel18').hide();
     $('.tabs18 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs18 li:first a').click();
     
}); // end ready




















$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs19 a').click(function(){
  
     $('.panel19').hide();
     $('.tabs19 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs19 li:first a').click();
     
}); // end ready


$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs20 a').click(function(){
  
     $('.panel20').hide();
     $('.tabs20 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs20 li:first a').click();
     
}); // end ready



$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs21 a').click(function(){
  
     $('.panel21').hide();
     $('.tabs21 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs21 li:first a').click();
     
}); // end ready






$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs22 a').click(function(){
  
     $('.panel22').hide();
     $('.tabs22 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs22 li:first a').click();
     
}); // end ready








$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs23 a').click(function(){
  
     $('.panel23').hide();
     $('.tabs23 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs23 li:first a').click();
     
}); // end ready



$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs24 a').click(function(){
  
     $('.panel24').hide();
     $('.tabs24 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs24 li:first a').click();
     
}); // end ready




$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs25 a').click(function(){
  
     $('.panel25').hide();
     $('.tabs25 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs25 li:first a').click();
     
}); // end ready









$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs26 a').click(function(){
  
     $('.panel26').hide();
     $('.tabs26 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs26 li:first a').click();
     
}); // end ready






$(document).ready(function() {
    
    //alert('here');
	
  $('.tabs27 a').click(function(){
  
     $('.panel27').hide();
     $('.tabs27 a.active').removeClass('active');
     $(this).addClass('active');
     
     var panelss1234 = $(this).attr('href');
     $(panelss1234).fadeIn(1000);
     
     return true;  // prevents link action
    
  });  // end click 

     $('.tabs27 li:first a').click();
     
}); // end ready












$(document).ready(function(){
  function setCookie(cname,cvalue,exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    let user = getCookie("username");
    if (user != "") {
      alert("Welcome again " + user);
    } else {
      user = prompt("Please enter your name:","");
      if (user != "" && user != null) {
        setCookie("username", user, 30);
      }
    }
  }
  
  $('.language_selector').change(function(e){
    e.preventDefault();
    var lang = $(this).val();
    var currency = $('.language_selector option:selected').attr('data-currency');
    
//     Cookies.set('lang', lang);
//     Cookies.set('currency', currency);
    
    setCookie('lang', lang, 30);
    setCookie('currency', currency, 30);
    
    Weglot.switchTo(lang);
    setTimeout(function(){
        $('.currency-selector option').removeAttr('selected');
        $('.currency-selector option[value="'+currency+'"]').attr('selected','selected');
        $('.currency-selector').trigger('change');
    }, 1500);
    
  });
  
  $('.header-language_selector .item').click(function(e){
    e.preventDefault();
    $('.header-language_selector .item').removeClass('active');
    $(this).addClass('active');
    var lang = $(this).attr('data-value');
    var currency = $(this).attr('data-currency');  
    setCookie('lang', lang, 30);
    setCookie('currency', currency, 30);
    if(lang == "en"){
    let did_find = false;
    let url_to_move_to = "";
    $.each(Weglot.options.languages,function(ix,em){
      if( em.language_to == lang ) {
        did_find = true;
        let current_path = window.location.pathname;
        url_to_move_to = em.connect_host_destination.host + current_path + "?currency=" + currency;
        console.log(url_to_move_to);
        return false;
      }
    });
    if(did_find == true) {
      window.location = 'https://'+url_to_move_to;
    } 
      else {
      let current_url = 'https://labfresh.eu/'+window.location.pathname;
      if(current_url.indexOf("?") !== -1) {
        current_url += '&currency='+currency;
      } else {
        current_url += '?currency='+currency;
      }
      window.location = current_url;
    }
    }else {
       Weglot.switchTo(lang);
    }
    
//     Weglot.switchTo(lang);
//     if(lang == "en"){
//     setTimeout(function(){
//         $('.currency-selector option').removeAttr('selected');
//         $('.currency-selector option[value="'+currency+'"]').attr('selected','selected');
//         $('.currency-selector').trigger('change');
//     }, 1500); }
   
   });

 
//   var cur_cookie = Cookies.get('currency');
//   var c_lang = Cookies.get('lang');
//   var c_currency = Cookies.get('currency');
  
  var cur_cookie = getCookie("currency");
  var c_lang = getCookie("lang");
  var c_currency = getCookie("currency");
  
  $('.language_selector option').removeAttr('selected');
  $('.language_selector option[value="'+c_lang+'"][data-currency="'+c_currency+'"]').attr('selected','selected');
  
  $('.header-language_selector .item').removeClass('active');
  $('.header-language_selector .item[data-value="'+c_lang+'"][data-currency="'+c_currency+'"]').addClass('active');
  
  $('.currency-selector option').removeAttr('selected');
  $('.currency-selector option[value="'+c_currency+'"]').attr('selected','selected');
//   $('.currency-selector').trigger('change');
  
  
  $('.Icon-flag').on('click', function() {
    // ExpandSelect("language__selector");

    // $('select').trigger('click');
  });

  function ExpandSelect(select, maxOptionsVisible)
  {

    //
    // ExpandSelect 1.00
    // Copyright (c) Czarek Tomczak. All rights reserved.
    //
    // License:
    //      New BSD License (free for any use, read more at https://www.opensource.org/licenses/bsd-license.php)
    //
    // Project's website:
    //      https://code.google.com/p/expandselect/
    //

    if (typeof maxOptionsVisible == "undefined") {
      maxOptionsVisible = 20;
    }
    if (typeof select == "string") {
      select = document.getElementById(select);
    }
    if (typeof window["ExpandSelect_tempID"] == "undefined") {
      window["ExpandSelect_tempID"] = 0;
    }
    window["ExpandSelect_tempID"]++;

    var rects = select.getClientRects();

    // ie: cannot populate options using innerHTML.
    function PopulateOptions(select, select2)
    {
      select2.options.length = 0; // clear out existing items
      for (var i = 0; i < select.options.length; i++) {
        var d = select.options[i];
        select2.options.add(new Option(d.text, i))
      }
    }

    var select2 = document.createElement("SELECT");
    //select2.innerHTML = select.innerHTML;
    PopulateOptions(select, select2);
    select2.style.cssText = "visibility: hidden;";
    if (select.style.width) {
      select2.style.width = select.style.width;
    }
    if (select.style.height) {
      select2.style.height = select.style.height;
    }
    select2.id = "ExpandSelect_" + window.ExpandSelect_tempID;

    select.parentNode.insertBefore(select2, select.nextSibling);
    select = select.parentNode.removeChild(select);

    if (select.length > maxOptionsVisible) {
      select.size = maxOptionsVisible;
    } else {
      select.size = select.length;
    }

    if ("pageXOffset" in window) {
      var scrollLeft = window.pageXOffset;
      var scrollTop = window.pageYOffset;
    } else {
      // ie <= 8
      // Function taken from here: http://help.dottoro.com/ljafodvj.php
      function GetZoomFactor()
      {
        var factor = 1;
        if (document.body.getBoundingClientRect) {
          var rect = document.body.getBoundingClientRect ();
          var physicalW = rect.right - rect.left;
          var logicalW = document.body.offsetWidth;
          factor = Math.round ((physicalW / logicalW) * 100) / 100;
        }
        return factor;
      }
      var zoomFactor = GetZoomFactor();
      var scrollLeft = Math.round(document.documentElement.scrollLeft / zoomFactor);
      var scrollTop = Math.round(document.documentElement.scrollTop / zoomFactor);
    }

    select.style.position = "absolute";
    select.style.left = (rects[0].left + scrollLeft) + "px";
    select.style.top = (rects[0].top + scrollTop) + "px";
    select.style.zIndex = "1000000";

    var keydownFunc = function(e){
      e = e ? e : window.event;
      // Need to implement hiding select on "Escape" and "Enter".
      if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
        return 1;
      }
      // Escape, Enter.
      if (27 == e.keyCode || 13 == e.keyCode) {
        select.blur();
        return 0;
      }
      return 1;
    };

    if (select.addEventListener) {
      select.addEventListener("keydown", keydownFunc, false);
    } else {
      select.attachEvent("onkeydown", keydownFunc);
    }

    var tempID = window["ExpandSelect_tempID"];

    var clickFunc = function(e){
      e = e ? e : window.event;
      if (e.target) {
        if (e.target.tagName == "OPTION") {
          select.blur();
        }
      } else {
        // IE case.
        if (e.srcElement.tagName == "SELECT" || e.srcElement.tagName == "OPTION") {
          select.blur();
        }
      }
    };

    if (select.addEventListener) {
      select.addEventListener("click", clickFunc, false);
    } else {
      select.attachEvent("onclick", clickFunc);
    }

    var blurFunc = function(){
      if (select.removeEventListener) {
        select.removeEventListener("blur", arguments.callee, false);
        select.removeEventListener("click", clickFunc, false);
        select.removeEventListener("keydown", keydownFunc, false);
      } else {
        select.detachEvent("onblur", arguments.callee);
        select.detachEvent("onclick", clickFunc);
        select.detachEvent("onkeydown", keydownFunc);
      }
      select.size = 1;
      select.style.position = "static";
      select = select.parentNode.removeChild(select);
      var select2 = document.getElementById("ExpandSelect_"+tempID);
      select2.parentNode.insertBefore(select, select2);
      select2.parentNode.removeChild(select2);

    };

    if (select.addEventListener) {
      select.addEventListener("blur", blurFunc, false);
    } else {
      select.attachEvent("onblur", blurFunc);
    }

    document.body.appendChild(select);
    select.focus();
  }
  
  
  $('.dropdown > .caption').on('click', function() {
    $(this).parent().toggleClass('open');
  });

  $('.dropdown > .list > .item').on('click', function() {
    $('.dropdown > .list > .item').removeClass('selected');
    $(this).addClass('selected').parent().parent().removeClass('open').children('.caption').text( $(this).text() );
  });

  $(document).on('keyup', function(evt) {
    if ( (evt.keyCode || evt.which) === 27 ) {
      $('.dropdown').removeClass('open');
    }
  });

  $(document).on('click', function(evt) {
    if ( $(evt.target).closest(".dropdown > .caption").length === 0 ) {
      $('.dropdown').removeClass('open');
    }
  });
  
  $('.styles_button__4YS3L').on('click', function(){
    var val = $(this).attr('data-toggle-value');
    
    if(val == 2){
      $(this).attr('data-toggle-value',1);
      $('.styles_button__4YS3L').attr('data-toggle-value',1);
      $('.styles_sizeChart__table__2aGcW .styles_sizeChart__cell__3psji').each(function(){
        var cm = $(this).attr('data-cm');
        $(this).show();
        $(this).text(cm);
      });
      
      var size = $(this).parents('.size_chart').find('.measurement.size_selected').attr('data-size');
      $('.mobile_sizechart').find('.styles_sizeChart__detail__3Rpb5').each(function(){
        var val = $(this).attr('data-'+size);
        $(this).text(val);
      });
      
    }
    else if(val == 1){
      $(this).attr('data-toggle-value',2);
      $('.styles_button__4YS3L').attr('data-toggle-value',2);
      $('.styles_sizeChart__table__2aGcW .styles_sizeChart__cell__3psji').each(function(){
        var inch = $(this).attr('data-inch');
        if(inch == 'none'){
          $(this).hide();
        }
        else{
          $(this).text(inch);
        }
      });
      
      var size = $('.measurement.size_selected').attr('data-size');
      $('.mobile_sizechart').find('.styles_sizeChart__detail__3Rpb5').each(function(){
        var val = $(this).attr('data-inch-'+size);
        $(this).text(val);
      });
      
    }
  });
  
  
  $('.measurement').on('click', function() {
    $('.measurement').removeClass('size_selected');
    $(this).addClass('size_selected');
    
    var measure = $(this).parents('.size_chart').find('.styles_button__4YS3L').attr('data-toggle-value');
    
    if(measure == 1){
      var size = $(this).attr('data-size');
      $(this).parents('.mobile_sizechart').find('.styles_sizeChart__detail__3Rpb5').each(function(){
        var val = $(this).attr('data-'+size);
        $(this).text(val);
      });
    }
    else if(measure == 2){
      var size = $(this).attr('data-size');
      $(this).parents('.mobile_sizechart').find('.styles_sizeChart__detail__3Rpb5').each(function(){
        var val = $(this).attr('data-inch-'+size);
        $(this).text(val);
      });
    }
    
  });
  
  $("#size_selects").change(function(){
  });
        
  $(window).on('load', function(){
    if(window.location.href.indexOf('cart=open') > -1){
      $('#sidebar-cart').attr('aria-hidden','false');
    }
    else{
      $('#sidebar-cart').attr('aria-hidden','true');
    }
  });
  $('.Drawer__Close').on('click', function(){
    $('#sidebar-cart').attr('aria-hidden','true');
  });

  if(window.location.href.indexOf('nl') > -1){
    $('.dutch_flag').show();
  }
  else if(window.location.href.indexOf('da') > -1){
    $('.danish_flag').show();
  }
  else{
    $('.uk_flag').show();
  }
});
